import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  // ---- ACHIEVEMENT ---- //
  ACHIEVEMENT_CREATE_REQUESTING: null,
  ACHIEVEMENT_CREATE_SUCCEEDED: null,
  ACHIEVEMENT_CREATE_ERROR: null,
  ACHIEVEMENT_UPDATE_REQUESTING: null,
  ACHIEVEMENT_UPDATE_SUCCEEDED: null,
  ACHIEVEMENT_UPDATE_ERROR: null,
  ACHIEVEMENTS_ALL_REQUESTING: null,
  ACHIEVEMENTS_ALL_RECEIVED: null,
  ACHIEVEMENTS_ALL_ERROR: null,
  // ---- AWARD ---- //
  AWARD_PRIVATE_URLS_RECEIVED: null,
  AWARD_PRIVATE_URLS_REQUESTING: null,
  AWARD_PRIVATE_URLS_ERROR: null,
  AWARD_PUBLIC_URLS_REQUESTING: null,
  AWARD_PUBLIC_URLS_ERROR: null,
  AWARD_PUBLIC_URLS_RECEIVED: null,
  AWARD_VISIBILITY_CHANGE_REQUESTING: null,
  AWARD_VISIBILITY_CHANGE_RECEIVED: null,
  AWARD_VISIBILITY_CHANGE_ERROR: null,
  // ---- HOMEPAGE ---- //
  ALL_CONTENT_RECEIVED: null,
  ALL_CONTENT_REQUEST_ERROR: null,
  ALL_CONTENT_REQUESTING: null,
  ALL_COURSES_INVALIDATE: null,
  CLEAR_ALL_FILTERS: null,
  SET_SELECTED_CATEGORIES: null,
  SET_SELECTED_AWARD_FILTER: null,
  SET_SELECTED_USER_PROGRESS_FILTER: null,
  // ---- VIDEO ---- //
  SET_VIDEO_PLAY_SPEED: null,
  TOGGLE_AUTO_PLAY: null,
  // ---- PROGRESS TRANSFER --- //
  PROGRESS_TRANSFER_REQUESTING: null,
  PROGRESS_TRANSFER_REQUEST_COMPLETION: null,
  PROGRESS_TRANSFER_REQUEST_ERROR: null,
  VERIFY_PROGRESS_TRANSFER_REQUESTING: null,
  VERIFY_PROGRESS_TRANSFER_SUCCESS: null,
  VERIFY_PROGRESS_TRANSFER_ERROR: null,
  // ---- UPWORK ---- //
  SEND_TO_UPWORK_REQUESTING: null,
  SEND_TO_UPWORK_REQUEST_SUCCESS: null,
  SEND_TO_UPWORK_REQUEST_ERROR: null,
  // ---- ALERTS ---- //
  DISMISS_INVITE_TEAM_ALERT: null,
  // ---- EXAM ---- //
  EXAM_START_REQUESTING: null,
  EXAM_START_RECEIVED: null,
  EXAM_START_ERROR: null,
  EXAM_RESUME_REQUESTING: null,
  EXAM_RESUME_RECEIVED: null,
  EXAM_RESUME_ERROR: null,
  EXAM_VALIDATE_REQUESTING: null,
  EXAM_VALIDATE_RECEIVED: null,
  EXAM_VALIDATE_ERROR: null,
  EXAM_RESET_CURRENT_ATTEMPT: null,
  EXAM_ADD_ANSWER_REQUESTING: null,
  EXAM_ADD_ANSWER_RECEIVED: null,
  EXAM_ADD_ANSWER_ERROR: null,
  EXAM_SEND_EMAIL_BREAKDOWN_REQUESTING: null,
  EXAM_SEND_EMAIL_BREAKDOWN_SUCCESS: null,
  EXAM_SEND_EMAIL_BREAKDOWN_ERROR: null,
  // ---- LESSONS ---- //
  GET_LESSON_BY_ID_REQUESTING: null,
  GET_LESSON_BY_ID_RECEIVE: null,
  GET_LESSON_BY_ID_ERROR: null,
  GET_LESSONS_BY_ID_RECEIVE: null,
  GET_LESSONS_REQUESTING: null,
  GET_LESSONS_ERROR: null,
  GET_RECOMMENDED_LESSONS_REQUESTING: null,
  GET_RECOMMENDED_LESSONS_RECEIVED: null,
  GET_RECOMMENDED_LESSONS_ERROR: null,
  // --- TRACKS --- //
  TRACK_BY_ID_REQUESTING: null,
  TRACK_BY_ID_RECEIVE: null,
  TRACK_BY_ID_ERROR: null,
  TRACKS_REQUESTING: null,
  TRACKS_RECEIVED: null,
  TRACKS_BY_ID_RECEIVED: null,
  TRACKS_ERROR: null,
  GET_RECOMMENDED_TRACKS_REQUESTING: null,
  GET_RECOMMENDED_TRACKS_ERROR: null,
  GET_RECOMMENDED_TRACKS_RECEIVED: null,
  // ---- FILTERS ---- //
  FILTERS_REQUESTING: null,
  FILTERS_RECEIVED: null,
  FILTERS_ERROR: null,
  // ---- BOOKMARKS ---- //
  BOOKMARKS_GET_REQUESTING: null,
  BOOKMARKS_GET_RECEIVED: null,
  BOOKMARKS_GET_ERROR: null,
  BOOKMARKS_EDIT_TRACK_REQUESTING: null,
  BOOKMARKS_ADD_TRACK_RECEIVED: null,
  BOOKMARKS_REMOVE_TRACK_RECEIVED: null,
  BOOKMARKS_EDIT_TRACK_ERROR: null,
  BOOKMARKS_EDIT_LESSON_REQUESTING: null,
  BOOKMARKS_ADD_LESSON_RECEIVED: null,
  BOOKMARKS_REMOVE_LESSON_RECEIVED: null,
  BOOKMARKS_EDIT_LESSON_ERROR: null,
  BOOKMARKS_TOGGLE_OPT_IN: null,
  BOOKMARKS_CLEAR_TOOLTIP: null,
  // ---- GETTING_STARTED ---- //
  GETTING_STARTED_GET_REQUESTING: null,
  GETTING_STARTED_GET_RECEIVED: null,
  GETTING_STARTED_GET_ERROR: null,
  GETTING_STARTED_ENROLL_ERROR: null,
  // ---- PUBLIC API ---- //
  PUBLIC_AWARD_INFO_REQUESTING: null,
  PUBLIC_AWARD_INFO_RECEIVED: null,
  PUBLIC_AWARD_INFO_ERROR: null,
  PUBLIC_ACHIEVEMENT_REQUESTING: null,
  PUBLIC_ACHIEVEMENT_RECEIVED: null,
  PUBLIC_ACHIEVEMENT_ERROR: null,
  // ---- AVAILABLE LANGUAGES ---- //
  AVAILABLE_LANGUAGES_BY_TRACK_ID_REQUESTING: null,
  AVAILABLE_LANGUAGES_BY_TRACK_ID_RECEIVED: null,
  AVAILABLE_LANGUAGES_BY_TRACK_ID_ERROR: null,
  AVAILABLE_LANGUAGES_BY_LESSON_ID_REQUESTING: null,
  AVAILABLE_LANGUAGES_BY_LESSON_ID_RECEIVED: null,
  AVAILABLE_LANGUAGES_BY_LESSON_ID_ERROR: null,
  // ---- RECOMMENDATIONS ---- //
  RECOMMENDATIONS_REQUESTING: null,
  RECOMMENDATIONS_RECEIVED: null,
  RECOMMENDATIONS_ERROR: null,
  TOPIC_PREFERENCES_REQUESTING: null,
  TOPIC_PREFERENCES_RECEIVED: null,
  TOPIC_PREFERENCES_ERROR: null,
  SET_TOPIC_PREFERENCES_REQUESTING: null,
  SET_TOPIC_PREFERENCES_SUCCESS: null,
  SET_TOPIC_PREFERENCES_ERROR: null,
  // ---- ACADEMY TO SOFTWARE ---- //
  ACADEMY_TO_SOFTWARE_SET_MODAL_OPEN: null,
  ACADEMY_TO_SOFTWARE_SET_MODAL_CLOSED: null,
  ACADEMY_TO_SOFTWARE_SHOW_TOOLTIP: null,
  ACADEMY_TO_SOFTWARE_HIDE_TOOLTIP: null,
  // ---- TREATMENTS ---- //
  SET_TREATMENTS: null,
  // ---- ACCOUNTS ---- //
  ACCOUNTS_REQUESTING: null,
  ACCOUNTS_RECEIVED: null,
  ACCOUNTS_ERROR: null,
  // ---- USER ATTRIBUTES ---- //
  GET_USER_ATTRIBUTES_REQUESTING: null,
  GET_USER_ATTRIBUTES_RECEIVED: null,
  GET_USER_ATTRIBUTES_ERROR: null,
  SET_USER_ATTRIBUTES_REQUESTING: null,
  SET_USER_ATTRIBUTES_SUCCESS: null,
  SET_USER_ATTRIBUTES_ERROR: null,
  SET_USER_ATTRIBUTE_LOCAL: null,
  UNSET_USER_ATTRIBUTE_REQUESTING: null,
  UNSET_USER_ATTRIBUTE_SUCCESS: null,
  UNSET_USER_ATTRIBUTE_ERROR: null,
  UNSET_USER_ATTRIBUTE_LOCAL: null,
  // ---- WIZARD ---- //
  WIZARD_SET_PROGRESS_PANEL_EXPANDED: null,
  // ---- PRODUCTS ---- //
  PRODUCTS_REQUESTING: null,
  PRODUCTS_RECEIVED: null,
  PRODUCTS_ERROR: null,
  // ---- NAV CONFIG ---- //
  NAV_CONFIG_REQUESTING: null,
  NAV_CONFIG_RECEIVED: null,
  NAV_CONFIG_ERROR: null,
  NAV_CONFIG_HOME_OPTIONS_REQUESTING: null,
  NAV_CONFIG_HOME_OPTIONS_RECEIVED: null,
  NAV_CONFIG_HOME_OPTIONS_ERROR: null,
  NAV_CONFIG_HOME_KEY_REQUESTING: null,
  NAV_CONFIG_HOME_KEY_RECEIVED: null,
  NAV_CONFIG_HOME_KEY_ERROR: null
});